import { create } from 'zustand';
import { UserAction, UserState } from './user.type';

const initialState: UserState = {
  user: null,
};

export const useUserStore = create<UserState & UserAction>((set) => ({
  ...initialState,
  setCurrentUser: (user: UserState['user']) => set({ user }),
  removeCurrentUser: () => set(initialState),
}));

export const setCurrentUser = (user: UserState['user']) => {
  useUserStore.setState({ user });
};

export const removeCurrentUser = () => {
  useUserStore.setState(initialState);
};
